import { render, staticRenderFns } from "./EmailTypeManager.vue?vue&type=template&id=b44bc7c0&scoped=true"
import script from "./EmailTypeManager.ts?vue&type=script&lang=js&external"
export * from "./EmailTypeManager.ts?vue&type=script&lang=js&external"
import style0 from "./EmailTypeManager.scss?vue&type=style&index=0&id=b44bc7c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44bc7c0",
  null
  
)

export default component.exports